export const toastMessageType = {
  SUCCESS: 'success',
  FAILED: 'failed',
  INFO: 'info',
  WARNING: 'warning',
};
